/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */
import { compose } from '@reduxjs/toolkit'
import type { State } from '@zcode/state-type'

export const selectGlobalNav = (state: State) => state.globalNav

export const selectGlobalNavLinks = compose((state) => state.links, selectGlobalNav)

export const selectGlobalNavAFRLinks = compose((state) => state?.urls ?? [], selectGlobalNavLinks)

export const selectGlobalNavHFRLinks = compose(
  (state) => state?.propertyType?.houses ?? [],
  selectGlobalNavLinks
)

export const selectGlobalNavRFRLinks = compose(
  (state) => state?.propertyType?.rooms ?? [],
  selectGlobalNavLinks
)

export const selectGlobalNavMeta = compose((state) => state.meta, selectGlobalNav)
